import styled from 'styled-components';

import { getCombinedClassNames } from 'utils/style';

import themConfigs from 'config/theme';

const fullConfig = { theme: themConfigs };

const PopularActivityWrapper = styled.div.attrs(() => {
  const classNameToAdd = ['u-block-margins'];
  return {
    className: getCombinedClassNames(classNameToAdd),
  };
})``;

const PopularActivityTitle = styled.h2.attrs(() => {
  const classNameToAdd = ['h3', 'text-basic-700', 'mb-4', 'lg:mb-8'];
  return {
    className: getCombinedClassNames(classNameToAdd),
  };
})``;

const PopularActivityCard = styled.a`
  height: 340px;

  @media (min-width: ${fullConfig.theme.screens.sm}) {
    height: 475px;
  }

  @media (min-width: ${fullConfig.theme.screens.xl}) {
    height: 600px;
  }
`;

export { PopularActivityWrapper, PopularActivityTitle, PopularActivityCard };
